import ScrollReveal from 'scrollreveal';
import { FluentRevealEffect } from "fluent-reveal-effect";
document.addEventListener("DOMContentLoaded", function () {
  FluentRevealEffect.applyEffect(".header-logo, .btn:not(.btn-text), .animate-loop, .social-icon, #newsletter .frm-fluent-form", {
    lightColor: "rgba(255,255,255,0.2)",
    gradientSize: 150
  });
  FluentRevealEffect.applyEffect("div[id^='block-cta-block-'] input", {
    lightColor: "rgba(89,175,190,0.15)",
    gradientSize: 150
  });
  FluentRevealEffect.applyEffect(".animate-careers", {
    lightColor: "rgba(89,175,190,0.15)",
    gradientSize: 250
  });
  ScrollReveal().reveal('.fifty-fifty-img-txt-block .image-wrapper, .seventy-thirty-block .image-wrapper', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    afterReveal: function afterReveal(el) {
      el.removeAttribute("style");
    }
  });
  ScrollReveal().reveal('.fifty-fifty-img-txt-block .image-wrapper + div, .seventy-thirty-block .image-wrapper + div', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    delay: 250
  });
  ScrollReveal().reveal('.fifty-fifty-img-txt-full-width-block img', {
    duration: 1000
  });
  ScrollReveal().reveal('.fifty-fifty-img-txt-full-width-block .container', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    delay: 250
  });
  ScrollReveal().reveal('.featured-pages-block .container > a:nth-child(1)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    scale: 0.9
  });
  ScrollReveal().reveal('.featured-pages-block .container > a:nth-child(2)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    scale: 0.9,
    delay: 100
  });
  ScrollReveal().reveal('.featured-pages-block .container > a:nth-child(3)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    scale: 0.9,
    delay: 200
  });
  ScrollReveal().reveal('.content-slider-block .container > div:first-child', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom'
  });
  ScrollReveal().reveal('.content-slider-block .container', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    delay: 500,
    afterReveal: function afterReveal(el) {
      el.removeAttribute("style");
    }
  });
  ScrollReveal().reveal('.columns > .container > .flex > .column:nth-child(1)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom'
  });
  ScrollReveal().reveal('.columns > .container > .flex > .column:nth-child(2)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    delay: 100
  });
  ScrollReveal().reveal('.columns > .container > .flex > .column:nth-child(3)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    delay: 200
  });
  ScrollReveal().reveal('.columns > .container > .flex > .column:nth-child(4)', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom',
    delay: 300
  });
  ScrollReveal().reveal('.footer-tile:nth-child(1) *', {
    duration: 1000,
    distance: '25px',
    origin: 'right'
  });
  ScrollReveal().reveal('.footer-tile:nth-child(2) *', {
    duration: 1000,
    distance: '25px',
    origin: 'right',
    delay: 100
  });
  ScrollReveal().reveal('.simple-content-block .first-mt-0:nth-child(1)', {
    duration: 1000,
    distance: '25px',
    origin: 'left'
  });
  ScrollReveal().reveal('.simple-content-block .first-mt-0:nth-child(2)', {
    duration: 1000,
    distance: '25px',
    origin: 'left',
    delay: 100
  });
  ScrollReveal().reveal('div[id^="block-cta-block-block_"] > .container > div:nth-child(1)', {
    duration: 1000,
    distance: '25px',
    origin: 'right'
  });
  ScrollReveal().reveal('div[id^="block-cta-block-block_"] > .container > div:nth-child(2)', {
    duration: 1000,
    distance: '25px',
    origin: 'left'
  });
  ScrollReveal().reveal('.feedback-block .testimonial-text-swiper', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom'
  });
  ScrollReveal().reveal('.jump-links-block-block nav', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom'
  });
  ScrollReveal().reveal('.image-carousel-block .ticker-wrapper', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom'
  });
  ScrollReveal().reveal('.testimonial-carousel-block .testimonial-carousel-swiper', {
    duration: 1000,
    distance: '25px',
    origin: 'bottom'
  });
  ScrollReveal().reveal('.animate-careers:not(.hs-animated)', {
    duration: 1000,
    distance: '25px',
    origin: 'left',
    opacity: 0,
    afterReveal: function afterReveal(el) {
      el.classList.add('hs-animated');
    }
  }); //get loop items

  var loop_items = [document.querySelectorAll('.animate-loop:not(.hs-animated)'), document.querySelectorAll('.accordion-trigger-container:not(.hs-animated)'), document.querySelectorAll('.team-member:not(.hs-animated)'), document.querySelectorAll('.process-step:not(.hs-animated)'), document.querySelectorAll('.outcome-item:not(.hs-animated)'), document.querySelectorAll('.feature-stat-item:not(.hs-animated)')]; //if we have some loop items

  if (loop_items) {
    //loop over the groups of items
    for (var i = 0; i < loop_items.length; i++) {
      //move the groups to a variable
      var loop_group = loop_items[i]; //loop over the loop items (heh)

      for (var ii = 0; ii < loop_group.length; ii++) {
        //add a reveal animation to this item, the delay increased from the last
        ScrollReveal().reveal(loop_group[ii], {
          duration: 1000,
          opacity: 0,
          delay: ii * 25,
          afterReveal: function afterReveal(el) {
            el.classList.add('hs-animated');
          }
        });
      }
    }
  }
});